// add to cart fn

/* 
fetch(form.action, {
			method: form.method,
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				id: form.querySelector('input[name="id"]').value,
				quantity: form.querySelector('input[name="quantity"]').value,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.status === "success") {
					// Cart update successful, perform any necessary actions
					console.log("Cart updated successfully");
				} else {
					// Cart update failed, handle the error
					console.error("Cart update failed");
				}
			});

*/

// countdown for the product card and product page
document.addEventListener("DOMContentLoaded", () => {
  const timers = document.querySelectorAll(".countdown-timer");

  timers.forEach((timer) => {
    const countdownDate = new Date(
      timer.getAttribute("data-countdown")
    ).getTime();

    if (isNaN(countdownDate)) return;

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownDate - now;

      if (distance < 0) {
        clearInterval(interval);
        timer.innerHTML = `
        <span class="days">00</span>
          <span>:</span>
          <span class="hrs">00</span>
          <span>:</span>
          <span class="min">00</span>
          <span>:</span>
          <span class="sec">00</span>
          <span class="offer-expires">Offer Expired</span>
      `;
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timer.innerHTML = `
        <span class="days">${days}</span>
          <span>:</span>
          <span class="hrs">${hours}</span>
          <span>:</span>
          <span class="min">${minutes}</span>
          <span>:</span>
          <span class="sec">${seconds}</span>
          <span class="offer-expires">Offer Expires in</span>
      `;
    }, 1000);
  });
});

// product card add to cart
document.addEventListener("DOMContentLoaded", () => {
  cartEvent();
});

function cartEvent() {
  const cartCountElement = document.querySelector(".cart-count");
  const cartCountAnim = document.querySelector(".cart-anim-container span");
  const cartAnimContainer = document.querySelector(".cart-anim-container");
  const addToCartButtons = document.querySelectorAll(".product-card-cart-btn");
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const productId = button.getAttribute("data-product-id");

      button.querySelector(".loader").classList.remove("hidden");

      button.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            button.querySelector(".loader").classList.add("hidden");
            throw new Error("Failed to add to cart");
          }
          return fetch("/cart.js");
        })
        .then((response) => response.json())
        .then((cart) => {
          button.querySelector(".loader").classList.add("hidden");
          Toastify({
            text: "Product Added to Cart",
            gravity: "bottom",
          }).showToast();
          cartCountElement.textContent = cart.item_count;
          if (cartCountAnim) {
            cartCountAnim.textContent = cart.item_count;
          }

          button.disabled = false;
        })
        .catch((error) => console.error(error));
    });
  });
}
